module.exports = __webpack_public_path__ + "html/project-summary_4012fd37248e82a445e03a1908356b91.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/project-summary.html
// module id = O3cu
// module chunks = 151